<template>
	<div
		ref="floatingRef"
		class="z-999"
	>
		<div
			v-if="slots?.trigger != null"
			class="flex"
			@mouseenter="setShowTooltip"
			@mouseleave="hideTooltip"
		>
			<slot name="trigger" />
		</div>

		<Teleport to="#tooltips-container">
			<div
				v-if="showFloating"
				ref="floating"
				:style="{
					...floatingStyles,
					...positionStyles,
					visibility: middlewareData?.hide?.referenceHidden ? 'hidden' : 'visible'
				}"
				class="z-9997"
				@mouseenter="setShowTooltip"
				@mouseleave="hideTooltip"
			>
				<slot name="floating-content" />
			</div>
		</Teleport>
	</div>
</template>

<script setup>
import { ref, toRefs, useSlots, watch, computed } from 'vue';
import { useFloating, flip, offset, hide, shift, autoUpdate } from '@floating-ui/vue';
import { useMouse } from '@vueuse/core';

import { PLACEMENT_OPTIONS } from '../../utils/floating-ui';

const props = defineProps({
	placement: {
		default: 'bottom',
		validator: (prop) => PLACEMENT_OPTIONS.includes(prop)
	},
	show: { type: Boolean, default: false },
	showOnMousePosition: { type: Boolean, default: false },
	disabled: { type: Boolean, default: false }
});

const { placement, showOnMousePosition, disabled } = toRefs(props);
const slots = useSlots();

const floatingRef = ref(null);
const floating = ref(null);
const showFloating = ref(false);

let hideTimeout = null;

const setShowTooltip = () => {
	if (disabled.value) {
		return;
	}

	clearTimeout(hideTimeout);
	showFloating.value = true;
};

const hideTooltip = () => {
	if (disabled.value) {
		return;
	}

	clearTimeout(hideTimeout);

	hideTimeout = setTimeout(() => {
		showFloating.value = false;
	}, 200);
};

const { x, y } = useMouse();

const floatingData = ref({ floatingStyles: {}, middlewareData: {} });

watch(placement, () => {
	floatingData.value = useFloating(floatingRef, floating, {
		placement: placement.value,
		middleware: [flip(), shift(), offset(4), hide()],
		whileElementsMounted: autoUpdate,
	});
}, { immediate: true });

const floatingStyles = computed(() => floatingData.value.floatingStyles);
const middlewareData = computed(() => floatingData.value.middlewareData);

const positionStyles = computed(() => {
	return showOnMousePosition.value
		? { top: `${x.value}px !important`, left: `${y.value}px !important` }
		: {};
});
</script>
